<template>
    <div>
        <div class="field">
            <label class="label">Nombre</label>
            <p>{{ operator.name }}</p>
        </div>

        <div class="field">
            <label class="label">Email</label>
            <p>{{ operator.email }}</p>
        </div>

        <div class="field">
            <label class="label">Trámites</label>
            <div class="control" v-if="skills.length > 0">
                <div v-for="skill in skills" :key="skill.id">
                    {{ skill.id }}
                </div>
            </div>
            <div v-else class="control">
                Espere asignación...
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "operator-info",
    props: {
        operator: {
            type: Object,
            required: true,
        },
    },
    computed: {
        skills() {
            if (this.operator === null) {
                return [];
            }
            return this.operator.skills;
        },
    },
};
</script>
